import { formatItemValue } from '../../utils/formatting';
export const getFormattedValue = (value, key, itemsMap, convertToUTC = true, pivotValuesColumnsMap, parameters, timezone) => {
    const pivotValuesColumn = pivotValuesColumnsMap?.[key];
    const item = itemsMap[pivotValuesColumn?.referenceField ?? key];
    return formatItemValue(item, value, convertToUTC, parameters, timezone);
};
export const valueFormatter = (yFieldId, itemsMap, pivotValuesColumnsMap, parameters, timezone) => (rawValue) => getFormattedValue(rawValue, yFieldId, itemsMap, undefined, pivotValuesColumnsMap, parameters, timezone);
//# sourceMappingURL=valueFormatter.js.map